import { Source } from './source';
import { Custom } from './custom';
import { Initials } from './initials';
import { Value } from './value';

import { Injectable } from '@angular/core';
import { SourceCreator } from './source.creator';
import { AvatarSource } from './avatar-source.enum';

/**
 * Factory class that implements factory method pattern.
 * Used to create Source implementation class based
 * on the source Type
 */
@Injectable()
export class SourceFactory {
  private sources: { [key: string]: SourceCreator } = {};

  constructor() {
    this.sources[AvatarSource.CUSTOM] = Custom;
    this.sources[AvatarSource.INITIALS] = Initials;
    this.sources[AvatarSource.VALUE] = Value;
  }

  public newInstance(sourceType: AvatarSource, sourceValue: string): Source {
    return new this.sources[sourceType](sourceValue);
  }
}
